import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
    selector: 'app-pagination',
    templateUrl:'./pagination.html',
    styles: [
        ` .pagination {
            display: inline-block;
          }

          .pagination a {
            color: black;
            float: left;
            border-radius: 41px;
            padding: 1px 7px;
            text-decoration: none;
            transition: background-color .3s;
            border: 1px solid #4d7cfe;
            margin: 0 1px;
        
          }

          .pagination a.active {
            background-color: #4d7cfe;
            color: white;
            border: 1px solid #c5c5c7;
          }

          .pagination a:hover:not(.active) {background-color: #ddd}`
    ]
})
export class PaginationComponent {

  @Input()
  total: number = 0;

  @Input()
  page: number = 1;

  @Output()
  goTo: EventEmitter<number> = new EventEmitter<number>();

  constructor() { }

  totalPages() {
    return Math.ceil(this.total / 10);
  }

  pagesRange() {
    return this.range(1, this.totalPages() + 1);
  }

  prevPage() {
    return Math.max(1, this.page - 1);
  }

  nextPage() {
    return Math.min(this.totalPages(), this.page + 1);
  }

  pageClicked(page: number) {
    this.goTo.next(page);
  }

  range(start, stop, step=1){
    if (!stop) { start=0;stop=start; }
    return Array.from(new Array(Number((stop-start)/step)), (x,i) => start+ i*step)
  }
}
